import type { TRIOnsiteRecoveryProcessDataType } from '../../types/form-r.ts';
import type { CasOrCategory } from '../../types/db.ts';
import type { QuestionnaireAnswers } from '../../types/questionnaires.ts';
import type { Warning } from '../../types/tri.ts';

export function formRSection7bEnergyRecovery({
  chemicalName,
  casOrCategory,
  onSiteEnergyRecovery,
  warnings,
}: {
  chemicalName: string;
  casOrCategory: CasOrCategory;
  onSiteEnergyRecovery: QuestionnaireAnswers['onSiteEnergyRecovery'][CasOrCategory];
  warnings: Warning[];
}): TRIOnsiteRecoveryProcessDataType {
  if (!onSiteEnergyRecovery || onSiteEnergyRecovery.isApplicable === null) {
    warnings.push({
      warningID: 'TW1018',
      type: 'questionnaire',
      subType: 'onSiteEnergyRecovery',
      casOrCategory,
      message: `${chemicalName} (${casOrCategory}), missing answers.`,
      blocksPriorYearSection8Calculation: false,
    });
    onSiteEnergyRecovery = { isApplicable: false, methods: [] };
  } else if (onSiteEnergyRecovery.isApplicable && onSiteEnergyRecovery.methods.length === 0) {
    warnings.push({
      warningID: 'TW1019',
      type: 'questionnaire',
      subType: 'onSiteEnergyRecovery',
      casOrCategory,
      message: `${chemicalName} (${casOrCategory}), it was specified that energy recovery is performed, but no methods were provided.`,
      blocksPriorYearSection8Calculation: false,
    });
  }

  if (onSiteEnergyRecovery.isApplicable) {
    return {
      choice: 'EnergyRecoveryMethodCode',
      value: onSiteEnergyRecovery.methods,
    };
  } else {
    return {
      choice: 'NA',
      value: true,
    };
  }
}
